"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlParamsToObject = void 0;
const query_string_1 = require("query-string");
const urlParamsToObject = () => {
    return (0, query_string_1.parseUrl)(window.location.href, {
        parseBooleans: true,
        parseNumbers: true,
        arrayFormat: "bracket"
    }).query;
};
exports.urlParamsToObject = urlParamsToObject;
//# sourceMappingURL=urlParamsToObject.js.map